import axios from 'axios';

const ticketService = {
  async waiting(workstationId) {
    return axios.get(`/tickets/waiting?&workstationId=${workstationId}`);
  },
  async callNext(workstationId) {
    return axios.get(`/tickets/call/next?workstationId=${workstationId}`);
  },
  async ticketsInAttendanceByUser() {
    return axios.get('/users/attendance/tickets');
  },
  async attachCustomer(ticketId, customerId) {
    const url = `/tickets/${ticketId}/customers/${customerId}/attach`;
    return new Promise((resolve, reject) => {
      axios.put(url).then((resp) => resolve(resp)).catch((err) => reject(err));
    });
  },
  async saveDescription(ticketId, description) {
    const url = `/tickets/${ticketId}/save-description?d=${description}`;
    return axios.put(url);
  },
  async cancel(data) {
    return axios.put('/tickets/cancel', data);
  },
  async call(data) {
    return axios.put('/tickets/call', data);
  },
  async startAttendance(data) {
    return axios.put('/tickets/attendance/start', data);
  },
  async doneAttendance(data) {
    return axios.put('/tickets/attendance/done', data);
  },
  getServices(lineId) {
    return axios.get(`/lines/${lineId}/services`);
  },
  getTicketListByLabel(label, startDateTime, endDateTime) {
    return axios.get(`/tickets/search?label=${label}&startDateTime=${startDateTime}&endDateTime=${endDateTime}`);
  },
  getBasicInformation(ticketId) {
    return axios.get(`/tickets/${ticketId}/basic-information`);
  },
  async forward(data) {
    return axios.post('/tickets/attendance/forward', data);
  },
  async getTicketRatings() {
    return axios.get('/tickets/ratings');
  },
  async changeTicketRating(data) {
    return axios.put('/tickets/ratings/change', data);
  },
  async findTicketById(ticketId) {
    return axios.get(`/tickets/${ticketId}`);
  },
  getTicketListByLabelAndStatus(label, statusList) {
    return axios.get(`/tickets/search-by-status?label=${label}&statusList=${statusList}`);
  },
};

export default ticketService;
